import { Directive } from '@angular/core';

@Directive({
    selector: '[ccm-toggle-dropdown-off]',
    standalone: false,
})
export class FiToggleDropdownOffDirective {}
